export default __webpack_public_path__ + "static/media/emptyBg.72dfff84.svg";